export const surveillanceTopo = {
    namespaced: true,
    state: {
        startDate: new Date(new Date().getFullYear() - 1, 0, 1).getTime(),
        endDate: new Date(
            new Date().getFullYear(),
            new Date().getMonth(),
            new Date().getDate(),
            23, 59, 59, 999
        ).getTime() - new Date().getTimezoneOffset() * 60000,
        layers: {
            4: 'none',
            5: 'none',
            6: 'none',
        },
        idVue: null,
        exaggerationFactor: 50,
        isMonochrome : false,
        opacity: 0.5,
        showLabels: true,
        isCheckedPlage: true,
        pointsTopos: [],
        dataMode6: 'brutes',
        configEchelle:{
            4: {
                selectedMode: 'auto',
                fixeDz: { min: 0, max: 0 },
                intervals: [],
                palette: "viridis"
            },
            5: {
                selectedMode: 'auto',
                fixeDz: { min: 0, max: 0 },
                intervals: [],
                palette: "viridis"
            }
        },
        zoom: null,
        nbRows: 10,
        intervals: [],

    },
    getters: {
        startDate: state => state.startDate,
        endDate: state => state.endDate,
        layers: state => state.layers,
        getLayer: (state) => (graph) => {
            return state.layers[graph] || 'none';
        },
        exaggerationFactor: state => state.exaggerationFactor,
        isMonochrome : state => state.isMonochrome,
        opacity: state => state.opacity,
        showLabels: state => state.showLabels,
        getState: state => state,
        isCheckedPlage: state => state.isCheckedPlage,
        pointsTopos: state => state.pointsTopos,
        affiliation: state => state.affiliation,
        zoom: state => state.zoom,
        nbRows: state => state.nbRows,
        idVue: state =>state.idVue,
        configEchelle: state =>state.configEchelle,
        dataMode6: state => state.dataMode6,

    },
    mutations: {
        setDate(state, date) {
            state.startDate = date.start;
            state.endDate = date.end;
        },
        setLayer(state, layout) {
            state.layers = layout;
        },
        setIsCheckedPlage(state, value) {
            state.isCheckedPlage = value;

        },
        setZoom(state, value) {
            state.zoom = value;

        },
        setMonochrome(state, value) {
            state.isMonochrome = value;
        },
        setOpacity(state, value) {
            state.opacity = value;
        },
        setExaggerationFactor(state, factor) {
            state.exaggerationFactor = factor;
        },
        setPointsTopos(state, value) {
            state.pointsTopos = value;
        },
        setIdVue(state, value) {
            state.idVue = value;
        },
        toggleShowLabels(state, showLabels) {
            state.showLabels = showLabels;
        },
        toggleAffiliation(state, affiliation) {
            state.affiliation = affiliation;
        },
        setDataMode6(state, value) {
            state.dataMode6 = value;
        },
        setData(state, data) {
            const defaultState = {
                startDate: new Date(new Date().getFullYear() - 1, 0, 1).getTime(),
                endDate: new Date(
                    new Date().getFullYear(),
                    new Date().getMonth(),
                    new Date().getDate(),
                    23, 59, 59, 999
                ).getTime() - new Date().getTimezoneOffset() * 60000,
                layers: { 4: 'none', 5: 'none', 6: 'none' },
                exaggerationFactor: 50,
                showLabels: true,
                isCheckedPlage: true,
                pointsTopos: [],
                opacity: 0.5,
                isMonochrome: false,
                affiliation: false,
                zoom: null,
                nbRows: 10,
                idVue: null,
                dataMode6: 'brutes',
                configEchelle: {
                    4: {
                        selectedMode: 'auto',
                        fixeDz: { min: 0, max: 0 },
                        intervals: [],
                        palette: "viridis"
                    },
                    5: {
                        selectedMode: 'auto',
                        fixeDz: { min: 0, max: 0 },
                        intervals: [],
                        palette: "viridis"
                    }
                },

            };
            if (data !== null && data.parametres !== null) {
                const jsonData = JSON.parse(data.parametres);
                Object.assign(defaultState, {
                    startDate: defaultState.startDate,
                    endDate: defaultState.endDate,
                    layers: jsonData.layers ?? defaultState.layers,
                    exaggerationFactor: jsonData.exaggerationFactor ?? defaultState.exaggerationFactor,
                    showLabels: jsonData.showLabels ?? defaultState.showLabels,
                    isCheckedPlage: jsonData.isCheckedPlage ?? defaultState.isCheckedPlage,
                    pointsTopos: Array.isArray(jsonData.pointsTopos) ? jsonData.pointsTopos : [],
                    affiliation: jsonData.affiliation ?? defaultState.affiliation,
                    isMonochrome: jsonData.isMonochrome ?? defaultState.isMonochrome,
                    opacity: jsonData.opacity ?? defaultState.opacity,
                    zoom: jsonData.zoom ?? defaultState.zoom,
                    nbRows: jsonData.nbRows ?? defaultState.nbRows,
                    idVue: jsonData.idVue ?? defaultState.idVue,
                    dataMode6: jsonData.dataMode6 ?? defaultState.dataMode6,
                    configEchelle: jsonData.configEchelle ?? defaultState.configEchelle
                });
            }
            Object.assign(state, defaultState);
        },
        setNbRows(state, value) {
            state.nbRows = value
        },
        setConfigEchelle(state,value) {
            state.configEchelle = value
        },

    },
    actions: {
        updateDate({commit}, date) {
            commit('setDate', date);
        },
        updateLayer({commit}, payload) {
            commit('setLayer', payload);
        },
        updateExaggerationFactor({commit}, factor) {
            commit('setExaggerationFactor', factor);
        },
        toggleLabels({commit}, showLabels) {
            commit('toggleShowLabels', showLabels);
        },
        updateData({commit}, data) {
            commit('setData', data);
        },
        updatePointsTopos({commit}, value) {
            commit('setPointsTopos', value);
        },
        updateIdVue({commit}, value) {
            commit('setIdVue', value);
        },
        updateCheckedPlage({commit},data){
            commit('setIsCheckedPlage',data);
        },
        updateMonochrome({commit},value){
            commit('setMonochrome',value);
        },
        updateOpacity({commit},value){
            commit('setOpacity',value);
        },
        updateZoom({commit},data){
            commit('setZoom',data);
        },
        updateAffiliation({commit},data){
            commit('toggleAffiliation',data);
        },
        updateNbRows({ commit }, value) {
            commit('setNbRows', value)
        },
        updateConfigEchelle({commit},value){
            commit('setConfigEchelle',value)
        },
        updateDataMode6({commit}, value) {
            commit('setDataMode6', value);
        }

    }
};
